import _ from 'lodash';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';

import { CheckCircleTwoTone } from '@ant-design/icons';
import { Spin } from 'antd';

import HighchartsReact from 'highcharts-react-official';
import ReportsDataStore from 'stores/ReportsDataStore';

const NoIssuesSection = styled.div`
  display: flex;
  align-items: center;

  p {
    margin-bottom: 0px;
    font-size: 14px;
  }

  svg {
    font-size: 36px;
    margin-right: 12px;
  }
`;

const BarChart = ({ data, history, loaded }) => {
  const { xAxis, yAxis, value, key } = data;

  const vehicleHealthScoreReport = useMemo(
    () => toJS(ReportsDataStore.vehicleHealthScoreReport),
    []
  );

  const chartOptions = useMemo(() => {
    return {
      chart: {
        height: 500,
        type: 'column',
      },
      title: { text: undefined },
      exporting: { enabled: false },
      credits: { enabled: false },
      plotOptions: {
        series: {
          borderWidth: 0,
          dataLabels: {
            enabled: true,
            format: '{point.y:.2f}',
          },
          events: {
            click: (event) => {
              const clickedPointName = event.point.category;

              const clickedCar = _.filter(
                vehicleHealthScoreReport.data,
                (report) => report.carName === clickedPointName
              );

              if (!_.isEmpty(clickedCar)) {
                history.push(`/car/${clickedCar[0].carId}/general`);
              }
            },
          },
        },
      },
      xAxis: {
        title: {
          text: `<b>${xAxis}</b>`,
        },
        categories: _.map(value, (v) => v.name),
        labels: {
          rotation: -45,
          style: {
            fontSize: '10px',
            fontFamily: 'Verdana, sans-serif',
          },
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: `<b>${yAxis}</b>`,
        },
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        enabled: false,
      },
      series: [
        {
          name: key,
          data: value,
        },
      ],
    };
  }, [xAxis, yAxis, value, key, vehicleHealthScoreReport, history]);

  if (!loaded) {
    return <Spin />;
  }

  if (_.isEmpty(value)) {
    return (
      <NoIssuesSection>
        <CheckCircleTwoTone />
        <p>You have no {key} data!</p>
      </NoIssuesSection>
    );
  }

  return <HighchartsReact options={chartOptions} />;
};

BarChart.propTypes = {
  data: PropTypes.object,
  history: PropTypes.object,
  loaded: PropTypes.bool,
};

export default withRouter(observer(BarChart));
